"use strict";
module.exports = require("./jsC8").default;
module.exports.default = module.exports;
Object.defineProperty(module.exports, "__esModule", { value: true });
